import { render, staticRenderFns } from "./CertificatesTable.vue?vue&type=template&id=e3b1c908&scoped=true&"
import script from "./CertificatesTable.vue?vue&type=script&lang=js&"
export * from "./CertificatesTable.vue?vue&type=script&lang=js&"
import style0 from "./CertificatesTable.vue?vue&type=style&index=0&id=e3b1c908&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3b1c908",
  null
  
)

export default component.exports